var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrmDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27116_49292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4147 10.0013C18.4147 5.39893 14.6837 1.66797 10.0814 1.66797C5.47901 1.66797 1.74805 5.39893 1.74805 10.0013C1.74805 14.6036 5.47901 18.3346 10.0814 18.3346C14.6837 18.3346 18.4147 14.6036 18.4147 10.0013Z",
    stroke: "#A9B1C1",
    strokeWidth: 1.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.082 7L7.08203 13M13.082 13L7.08203 7",
    stroke: "#A9B1C1",
    strokeWidth: 1.67,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27116_49292"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.0820312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrmDelete);
export default __webpack_public_path__ + "static/media/crm-delete.ec965db74727f9c4177d377925d6b512.svg";
export { ForwardRef as ReactComponent };